import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatTableModule} from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatRadioModule} from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FeatherModule } from 'angular-feather';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '../shared/shared.module';
import { allIcons } from 'angular-feather/icons';
import { MatSnackBar } from '@angular/material/snack-bar';
@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatFormFieldModule,
    MatRadioModule,
    MatDialogModule,
    MatIconModule,
    FeatherModule,
    MatMenuModule,
    SharedModule,
    FeatherModule.pick(allIcons),
    // MatSnackBar
    
  ],
  providers:[
    MatSnackBar
  ]
})
export class InfrastructureModule { }
